import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from '../constant/ConversionRateConstant';

var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
var assign = require('object-assign');

var response = {};

function parseResponse(resp) {
    response = resp;
}
var GetLocationChartStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    },
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.LOCATION_RATES:
            var resp = action.data;
            parseResponse(resp)
            GetLocationChartStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
        default:
    }
});

export default GetLocationChartStore;